var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-container" }, [
    !_vm.saved && !_vm.readOnly
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 pt-0" }, [
            _c("div", { staticClass: "color-secondary-6 font-16 d-block" }, [
              _vm._v(" Documento: ")
            ]),
            _c("span", { staticClass: "text-format" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("validation-provider", {
                  attrs: { name: "Archivo", rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "color-secondary-6 font-16 d-block"
                              },
                              [_vm._v(" Archivo: ")]
                            ),
                            _c("custom-file-input", {
                              ref: "attachedDocument",
                              staticClass: "custom-file-input__extended",
                              attrs: {
                                accept: _vm.allowedFiles,
                                "custom-error-msg":
                                  "Favor de anejar el documento.",
                                "display-style": "normal",
                                error: errors[0],
                                label: "",
                                "label-position": "left",
                                required: ""
                              },
                              on: { input: _vm.handleChangeFile },
                              model: {
                                value: _vm.document,
                                callback: function($$v) {
                                  _vm.document = $$v
                                },
                                expression: "document"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3769697501
                  )
                }),
                _vm.canShowCancel
                  ? _c("action-button", {
                      staticClass: "mt-4 ml-3",
                      attrs: {
                        i: "fas fa-times-circle",
                        text: "Cancelar",
                        variant: "outline-danger"
                      },
                      on: { click: _vm.cancel }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "col-12 mt-3 mt-md-2 d-flex justify-content-end" },
            [
              false
                ? _c("action-button", {
                    attrs: {
                      i: "fa fa-file-plus",
                      text: "Añadir",
                      variant: "success"
                    },
                    on: { click: _vm.saveDocument }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col-12 col-md-10" }, [
            _c("div", { staticClass: "color-secondary-6 font-16 d-block" }, [
              _vm._v(_vm._s(_vm.title) + ":")
            ]),
            _vm.data
              ? _c("span", { staticClass: "text-format" }, [
                  _vm._v(_vm._s(_vm.data.name))
                ])
              : _vm._e()
          ]),
          !_vm.readOnly
            ? _c(
                "div",
                { staticClass: "col-12 col-md-2 text-right" },
                [
                  _c("drop-down", {
                    staticClass: "documents-action",
                    attrs: { items: _vm.actionItems }
                  })
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("action-button", {
                    staticClass: "mt-4 ml-3",
                    attrs: {
                      i: "fas fa-file-download",
                      text: "",
                      variant: "outline-success"
                    },
                    on: { click: _vm.downloadFile }
                  })
                ],
                1
              )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }